export default function EmailIcon({
  size = 'w-[26px] h-[26px]',
  color = 'white',
}) {
  return (
    <svg
      className={size}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.30771 5.73438H22.6923V19.4651C22.6923 19.6794 22.6072 19.8848 22.4558 20.0363C22.3043 20.1877 22.0988 20.2728 21.8846 20.2728H4.1154C3.90119 20.2728 3.69575 20.1877 3.54428 20.0363C3.3928 19.8848 3.30771 19.6794 3.30771 19.4651V5.73438Z"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6923 5.73438L13 14.619L3.30771 5.73438"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
